import { render, staticRenderFns } from "./PeriodicReportStudentList.vue?vue&type=template&id=fda9026c&scoped=true"
import script from "./PeriodicReportStudentList.vue?vue&type=script&lang=js"
export * from "./PeriodicReportStudentList.vue?vue&type=script&lang=js"
import style0 from "./PeriodicReportStudentList.vue?vue&type=style&index=0&id=fda9026c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda9026c",
  null
  
)

export default component.exports